// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "label.checkbox[data-v-8d2553e2]:not(:last-child) {\n  margin-right: 1.5rem;\n}", ""]);
// Exports
module.exports = exports;
